// SHADOW MARKET™ — Kids TTS hook using browser Web Speech API (free, offline).
import { useCallback, useEffect, useRef, useState } from "react";

const LANG_CODE = { es: "es-ES", en: "en-US", sk: "sk-SK" };

export function useKidsTTS(lang = "es") {
  const [hablando, setHablando] = useState(false);
  const synthRef = useRef(null);
  const voicesRef = useRef([]);

  useEffect(() => {
    if (typeof window === "undefined" || !window.speechSynthesis) return;
    synthRef.current = window.speechSynthesis;
    const loadVoices = () => {
      voicesRef.current = synthRef.current.getVoices();
    };
    loadVoices();
    synthRef.current.addEventListener("voiceschanged", loadVoices);
    return () => {
      try { synthRef.current?.cancel(); } catch {}
      synthRef.current?.removeEventListener("voiceschanged", loadVoices);
    };
  }, []);

  const hablar = useCallback(
    (texto, onEnd) => {
      if (!synthRef.current || !texto) return;
      synthRef.current.cancel();
      const utt = new window.SpeechSynthesisUtterance(texto);
      utt.lang = LANG_CODE[lang] || LANG_CODE.es;
      utt.rate = 0.88; // slightly slower for kids
      utt.pitch = 1.15;
      utt.volume = 1.0;
      const wanted = utt.lang.split("-")[0];
      const voz =
        voicesRef.current.find((v) => v.lang.startsWith(wanted) && v.localService) ||
        voicesRef.current.find((v) => v.lang.startsWith(wanted)) ||
        voicesRef.current[0];
      if (voz) utt.voice = voz;
      utt.onstart = () => setHablando(true);
      utt.onend = () => {
        setHablando(false);
        if (onEnd) onEnd();
      };
      utt.onerror = () => setHablando(false);
      synthRef.current.speak(utt);
    },
    [lang]
  );

  const silenciar = useCallback(() => {
    try { synthRef.current?.cancel(); } catch {}
    setHablando(false);
  }, []);

  return { hablar, silenciar, hablando };
}
